// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HnfGE0Z2WOde3P {
  display: inherit;
  height: 16px;
  margin: 8px 4px 8px 4px;
  border-left: 1px solid var(--dynamic-text-transparent);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardHeaderButtonDivider": `HnfGE0Z2WOde3P`
};
export default ___CSS_LOADER_EXPORT___;
